export function initializeCustomParamsState() {
    return {
        equipmentFields: {},
        paramsList: []
    };
}

export async function mapSavedCustomParamsToState({ savedParams, loadFieldsFn }) {
    const equipmentFields = {};
    const paramsList = [];

    const uniqueEquipments = [...new Set(savedParams.map(p => p.equipamento_id).filter(Boolean))];

    await Promise.all(uniqueEquipments.map(async (equipId) => { await loadFieldsFn(equipId); }));

    savedParams.forEach((param) => {
        const fields = loadFieldsFn.getCache(param.equipamento_id) || [];

        equipmentFields[param.id] = fields;

        paramsList.push({
            id: param.id,
            name: param.nome,
            isActive: param.ativo ?? true,
            equipment: param.equipamento_id,
            equipmentField: param.parametro_id,
            alertValueStart: param.condicao?.alerta?.inicio ?? "",
            alertValueEnd: param.condicao?.alerta?.fim ?? "",
            criticalValueStart: param.condicao?.critico?.inicio ?? "",
            criticalValueEnd: param.condicao?.critico?.fim ?? "",
            exceededValueStart: param.condicao?.excedido?.inicio ?? "",
            exceededValueEnd: param.condicao?.excedido?.fim ?? "",
            scale: param.condicao?.escala || null,
            groupBy: param.condicao?.agrupamento || null
        });
    });

    return { equipmentFields, paramsList };
}

export function buildCustomParamsPayload(paramsList, isPayloadToSave) {
    return {
        condicoes: paramsList.map((param) => ({
            ...(param.isNewRegister ? {} : { id: param.id }),
            nome: param.name,
            tipo: "outro",
            parametro_id: param.equipmentField,
            ativo: param.isActive,
            condicao: {
                alerta: {
                    inicio: Number(param.alertValueStart),
                    fim: Number(param.alertValueEnd)
                },
                critico: {
                    inicio: Number(param.criticalValueStart),
                    fim: Number(param.criticalValueEnd)
                },
                excedido: {
                    inicio: Number(param.exceededValueStart),
                    fim: Number(param.exceededValueEnd)
                },
                escala: param.scale,
                agrupamento: param.groupBy
            },
            ...(!isPayloadToSave && { equipment: param.equipment }),
        }))
    };
}
